module.exports = __webpack_public_path__ + "img/arrow.475cd8fc.svg";